import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
    private showLoaderSubject = new Subject<any>();
    showLoader$ : Observable<any>=this.showLoaderSubject.asObservable();
  constructor() {
   }
    setLoader(isLoading){
        this.showLoaderSubject.next(isLoading);
    }

}
